import React from 'react';
import OurServices from '../OurServices/OurServices';

const Services = () => {
    return (
        <div>
            <OurServices />
        </div>
    );
};

export default Services;